import React, {useContext, useEffect} from 'react';
import {LEFT_NAV_HOME, NavArray, RIGHT_NAV, NavItem} from "./nav/DefaultNav";
import BaseNav from "./BaseNav";
import {AppContext} from '../context/app-context';
import UserBasedNav from './UserBasedNav';
import {ObservableVariables} from '../components/constants/observable-constants';
import {NavMenuItemType} from '../views/nav-menu/NavMenuSubmenuListItem';

export const mergeNavigationArray = (
  leftNav: NavItem[] | null,
  rightNav: NavArray | null
): NavMenuItemType[] => {
  const mergeArray = [
    ...(leftNav || []),
    ...(rightNav || []),
  ];
  return mergeArray.filter((menu): menu is NavMenuItemType =>
    menu !== null && menu !== undefined && typeof menu === 'object'
  );
}

const LandingNav: React.FC = () => {

  const appContext = useContext(AppContext)
  const {user} = appContext

  useEffect(() => {
    if (!user) return;
    ObservableVariables.PENDING_APPROVAL_COUNT.refreshData(appContext);
    ObservableVariables.PENDING_INVENTORY_CORRECTIONS_COUNT.refreshData(appContext);
  }, [user, appContext])

  return user ?
    <UserBasedNav
      isHomeNav={true}
    />
    :
    <BaseNav
      rightNavOptions={mergeNavigationArray(LEFT_NAV_HOME as NavMenuItemType[], RIGHT_NAV)}
      fontColorOverride={true}
      logoUrl={"/app-images/logo/secure-space_white-logo_WTG.svg"} leftNavOptions={[]}
    />
}

export default LandingNav;
